import { Flex, Box, StarRating, Text } from "../../../../../../mads";
import { NewWindow } from "../../../../../../mads/icons";
import { useI18n } from "../../../../../../shared/I18n";
import { TextLink } from "../TextLink/TextLink";

import React from "react";

export interface INewTabReviewRatingProps {
  rating: number;
  reviewLink: string;
  countContent: string;
  ariaContent?: string;
  isSimpleVjImproveActive?: boolean;
}

export function NewTabReviewRating({ reviewLink, countContent, rating }: INewTabReviewRatingProps) {
  const i18n = useI18n();
  const reviewAriaLabel = i18n.gettext(
    "{0} out of 5 stars. Link to {1} company ratings (opens in a new tab)",
    [rating.toString(), countContent],
  );
  const starRatingLabel = i18n.gettext("{0} out of 5 stars", [rating.toString()]);

  return (
    <Flex sx={{ flexDirection: "row", alignItems: "center" }}>
      <Box sx={{ marginRight: 8 }}>
        <StarRating size="sm" value={rating} ariaLabel={starRatingLabel} />
      </Box>
      <Text level={3}>
        <TextLink
          targetUrl={reviewLink}
          iconAfter={<NewWindow />}
          aria-label={reviewAriaLabel}
          sx={{ textDecorationLine: "none" }}
          data-testid={"inlineHeader-companyReviewLink"}
        >
          {countContent}
        </TextLink>
      </Text>
    </Flex>
  );
}
